// import vesselsCoords from './data/vessels-coords.json'

import GoogleMap from './google-map.vue'

export default {
  components: {
    GoogleMap
  },
  props: {
    vessels: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      vesselsCoords: this.vessels
    }
  },
  methods: {
    filteredVesselsCoords() {
      return vesselsCoords

      // var filteredVesselsCoords = [];
      // if (this.selectedVesselType) {
      //   this.vesselsCoords.filter((vesselCoords) => {
      //     if (vesselCoords.type.match(this.selectedVesselType)) {
      //       filteredVesselsCoords.push(vesselCoords)
      //     }
      //   });
      //   return filteredVesselsCoords;
      // } else {
      //   return this.vesselsCoords;
      // }
    },
    mapFullScreen() {
      console.log('map fullscreen');
      var map = document.querySelector(".gm-style");
      map.requestFullscreen();
    }
  }
}